import { openTranscriptModal } from "~/meetingRecorder/TranscriptModal";
import type { OpenTranscriptModalProps } from "~/meetingRecorder/TranscriptModal";
import openMeetingModal from "~/meetings/MeetingModal/openMeetingModal";

/**
 * Opens the appropriate recap modal based on the user's UX simplification setting.
 * - If UX simplification is enabled: opens MeetingModal
 * - If UX simplification is disabled: opens TranscriptModal
 *
 * @example
 * // Basic usage - works for both UX modes
 * openRecapModal({ noteId: "note123" });
 *
 * // With additional parameters (only used in old UX)
 * openRecapModal({
 *   recordingId: "rec123",
 *   timestamp: 30,
 *   openedFromMiniplayerClick: true,
 *   openedTab: "notes"
 * });
 *
 * // Migration from old code:
 * // Before:
 * // if (user.uxSimplificationEnabled) {
 * //   openMeetingModal({ noteId, timestamp });
 * // } else {
 * //   openTranscriptModal({ noteId, timestamp, openedTab });
 * // }
 * //
 * // After:
 * // openRecapModal({ noteId, timestamp, openedTab });
 */
export function openRecapModal(props: OpenTranscriptModalProps) {
	const {
		noteId,
		recordingId,
		timestamp,
		timestampEnd,
		openedFromMiniplayerClick,
		videoOriginRefs,
		openedTab,
		initialTranscriptModalSubTab,
	} = props;

	if (!noteId && !recordingId) {
		throw new Error("Either noteId or recordingId must be provided");
	}

	// Read the UX simplification setting from the HTML data attribute
	const uxSimplificationAttribute = document.documentElement.getAttribute("data-ux-simplification");
	const isUXSimplificationEnabled = uxSimplificationAttribute === "enabled";

	if (isUXSimplificationEnabled) {
		// Use the new UX (MeetingModal)
		openMeetingModal({
			noteId,
			recordingId,
			timestamp,
			timestampEnd,
		});
	} else {
		// Use the old UX (TranscriptModal)
		openTranscriptModal({
			noteId,
			recordingId,
			timestamp,
			timestampEnd,
			openedFromMiniplayerClick,
			videoOriginRefs,
			openedTab,
			initialTranscriptModalSubTab,
		});
	}
}
